export enum PasswordStrength {
  UNKNOWN = 'unknown',
  WEAK = 'weak',
  GOOD = 'good',
  STRONG = 'strong',
}

const passwordStrengthByScore: Record<number, PasswordStrength> = {
  0: PasswordStrength.WEAK,
  1: PasswordStrength.GOOD,
  2: PasswordStrength.STRONG,
  3: PasswordStrength.STRONG,
  4: PasswordStrength.STRONG,
};

export const getPasswordStrength = async (
  password = '',
): Promise<PasswordStrength> => {
  if (password.length === 0) {
    return PasswordStrength.UNKNOWN;
  }

  if (password.length < 8) {
    return PasswordStrength.WEAK;
  }

  const { default: zxcvbn } = await import('zxcvbn');
  return passwordStrengthByScore[zxcvbn(password).score];
};
